/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDouble } from '../../models/api-response-double';
import { PricingAnalyticsRequest } from '../../models/pricing-analytics-request';

export interface GetTotalCost$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  request: PricingAnalyticsRequest;
}

export function getTotalCost(http: HttpClient, rootUrl: string, params: GetTotalCost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDouble>> {
  const rb = new RequestBuilder(rootUrl, getTotalCost.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.query('request', params.request, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDouble>;
    })
  );
}

getTotalCost.PATH = '/v1/api/ui/meta-pricing-analytics/getTotalCost';
